import React from 'react'

import { Link } from 'react-router-dom'

import classes from './Menu.module.scss'

type HeaderMenuProps = {
  toggleMenu: () => void
}

type linkType = {
  text: string
  link: string
}

const HeaderMenu = (props: HeaderMenuProps): JSX.Element => {
  const { toggleMenu } = props
  const menuLinks: Array<linkType> = [
    { text: 'Главная', link: '/' },
    { text: 'Дистрибуция', link: '/distribution' },
    { text: 'Производство', link: '/production' },
    { text: 'Новости', link: '/news' },
    { text: 'KION Originals', link: '/catalog' },
    { text: 'Контакты', link: '/contacts' },
    { text: 'Комплаенс', link: '/compliance' },
    { text: 'О нас', link: '/about' },
  ]

  return (
    <ul className={classes.menu__items}>
      {menuLinks.map((link, i) => (
        <li key={i}>
          <Link
            to={link?.link}
            onClick={toggleMenu}
            className={classes.menu__link}
          >
            {link?.text}
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default HeaderMenu
